document.addEventListener("click", (event) => {
  const closeIcon = event.target.closest(".close-icon");
  if (closeIcon) {
    document.querySelector(".sticker-pop-up")?.classList.remove("open");
    return;
  }

  const swatch = event.target.closest(".image-swatch");
  if (!swatch) return;

  const beforeElement = window.getComputedStyle(swatch, "::before");
  const rect = swatch.getBoundingClientRect();
  const beforeWidth = Number.parseFloat(beforeElement.width) || 0;
  const beforeHeight = Number.parseFloat(beforeElement.height) || 0;
  const beforeRight = rect.right - (Number.parseFloat(beforeElement.right) || 0);
  const beforeTop = rect.top + (Number.parseFloat(beforeElement.top) || 0);
  const insidePreviewButton =
    event.clientX >= beforeRight - beforeWidth &&
    event.clientX <= beforeRight &&
    event.clientY >= beforeTop &&
    event.clientY <= beforeTop + beforeHeight;

  if (!insidePreviewButton) return;
  const imageUrl = swatch.querySelector("input[data-image]")?.dataset.image;
  const popup = document.querySelector(".sticker-pop-up");
  const render = document.querySelector(".sticker-render");
  if (!imageUrl || !popup || !render) return;

  event.preventDefault();
  const image = document.createElement("img");
  image.src = imageUrl;
  image.alt = swatch.querySelector(".image-swatch-img")?.alt || "Motivvorschau";
  render.replaceChildren(image);
  popup.classList.add("open");
});
